import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useEffect } from "react";
import { useAPIEditKendaraanService } from "../api/api-edit-kendaraan-service";
import {
  genElNumber,
  genElText,
} from "../../../../components/utils/EditorDialogElementGenerator";
import { ProgressSpinner } from "primereact/progressspinner";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";

const KendaraanServiceEdit = (props) => {
  const { visible, onHide, editorData, onConfirmed } = props;

  const {
    loading,
    data,
    setData,
    listService,
    setListService,
    fetchDataOrCreateNew,
    error,
    handleOnConfirm,
  } = useAPIEditKendaraanService({ onConfirmed });

  // use effect section

  useEffect(() => {
    if (visible) {
      fetchDataOrCreateNew({ id: editorData.id, extraData: editorData });
    }
  }, [visible]);

  // handle ui event section

  const handleOnChangeCheckService = (event, service) => {
    const newListService = listService.map((el) => {
      if (el.id === service.id) {
        return { ...el, selected: event.checked };
      }
      return el;
    });
    setListService(newListService);
  };

  // custom ui section

  const generateServiceItem = (listService) => {
    const columns = [];
    let column;
    for (let i = 0; i < listService.length; i++) {
      const service = listService[i];
      if (i % 8 === 0) {
        column = [];
        columns.push(column);
      }

      column.push(
        <div key={service.id} className="row-start-center w-full gap-2">
          <Checkbox
            checked={service.selected}
            onChange={(e) => {
              handleOnChangeCheckService(e, service);
            }}
          />
          <span className="font-semibold text-slate-500">{service.nama}</span>
        </div>
      );
    }
    return columns.map((column, index) => {
      return (
        <div key={`col-${index}`} className="col-start-center w-full gap-4">
          {column}
        </div>
      );
    });
  };

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          handleOnConfirm();
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "42rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={
        data.id && data.id > 0
          ? "Edit Kendaraan Service"
          : "Tambah Kendaraan Service"
      }
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
      contentClassName="py-4 !pb-6"
      pt={{ footer: { className: "py-4" }, header: { className: "py-4" } }}
    >
      <div className="col-start-center relative h-100 gap-3">
        <div className="row-start-start w-full gap-3">
          <span className="font-semibold text-slate-500">Nomor Polisi:</span>{" "}
          {data.nomor_polisi ?? "-"}
        </div>
        <div className="row-start-start w-full gap-3 pb-1">
          <span className="font-semibold text-slate-500">Jenis Mobil:</span>{" "}
          {data.jenis_mobil ?? "-"}
        </div>
        <Divider layout="horizontal" className="w-full m-0" />
        <div className="row-start-start w-full gap-3 pt-2">
          {generateServiceItem(listService)}
        </div>

        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default KendaraanServiceEdit;
